import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/backlog-helper.png'


const _hoisted_1 = { class: "goals-backlog" }
const _hoisted_2 = {
  key: 0,
  class: "backlog-helper"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "No goals available with unassigned tasks", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "goals-backlog__item" }
const _hoisted_7 = { class: "goals-backlog__item__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DailySyncTaskList = _resolveComponent("DailySyncTaskList")!
  const _component_AccordionItem = _resolveComponent("AccordionItem")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.goals.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createVNode(_component_Accordion, { default: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goals, (goal, index) => {
          return (_openBlock(), _createBlock(_component_AccordionItem, {
            key: goal.id,
            activeIndex: index,
            elevated: ""
          }, {
            "accordion-trigger": _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(goal.title) + " ", 1),
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.unassignedTasks(goal).length) + ")", 1)
                ]),
                _createElementVNode("div", {
                  class: "goals-backlog__chip",
                  style: _normalizeStyle(`color: var(--color-${goal.goalColor}); background-color: rgba(var(--color-${goal.goalColor}-rgb),.05); border-color: var(--color-${goal.goalColor});`)
                }, _toDisplayString(goal.goalRef), 5)
              ])
            ]),
            "accordion-content": _withCtx(() => [
              _createVNode(_component_DailySyncTaskList, {
                modelValue: goal.tasks,
                "onUpdate:modelValue": ($event: any) => ((goal.tasks) = $event),
                group: "my-tasks",
                isGoalBacklog: true,
                showAssignee: true,
                onChange: _ctx.updateTask,
                onDelete: _ctx.deleteTask,
                onDelay: _cache[0] || (_cache[0] = ($event: any) => (_ctx.manualDelay())),
                class: _normalizeClass({ 'daily-sync-list-saving': _ctx.isSaving })
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "onDelete", "class"])
            ]),
            _: 2
          }, 1032, ["activeIndex"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}